import { lazy } from 'react';

// project import
import Loadable from './Loadable';
import SaleLayout from '../layout/SaleLayout';

// data limit manage for show on page

const CustomerScreen = Loadable(lazy(() => import('../pages/sale/CustomerScreen')));
const PageNotFound = Loadable(lazy(() => import('../pages/PageNotFound')));

// ==============================|| MAIN ROUTING ||============================== //

const title = 'Thana';

const AdminRoutes = {
    element: <SaleLayout />,
    children: [
        {
            path: '/sale/customer/screen',
            element:
                <CustomerScreen
                    documentTitle={`Customer screen- ${title}`}
                    pageTitle='ຂາຍເຄື່ອງ POS'
                    menuActive='/sale'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                    packageBtnRole={['PK00', 'PK02', 'PK03']}
                />
        },
        {
            path: '/*',
            element: (
                <PageNotFound
                    documentTitle={`Page Not Found - ${title}`}
                    pageTitle=''
                    menuActive=''
                />
            )
        }
    ]
};

export default AdminRoutes;
